import React from 'react';
import PropTypes from 'prop-types';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

import { INVOICE_STATUSES } from '../../../utils/enumHelper';

class InvoiceStatusSelectComponent extends React.Component {
  render() {
    const {
      onChange,
      value,
      includeAllOption,
      includeDraftOption,
      disabled,
      size,
      ...rest
    } = this.props;
    // Open, Paid, Void,

    return (
      <FormControl size={size} fullWidth margin="none" {...rest}>
        <InputLabel id="invoice-status-select-label">Status</InputLabel>
        <Select
          labelId="invoice-status-select-label"
          id="invoice-status-select"
          value={value || ''}
          label="Status"
          onChange={onChange}
          disabled={disabled}

        >
          {includeAllOption && <MenuItem value="">All</MenuItem>}
          {INVOICE_STATUSES.filter((is) => includeDraftOption || is.enum !== 'Draft').map((nt) => (
            <MenuItem key={`invoice-status-menu-item-${nt.enum}`} value={nt.enum}>
              {nt.chip}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}

InvoiceStatusSelectComponent.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  includeAllOption: PropTypes.bool,
  includeDraftOption: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.string,
};

InvoiceStatusSelectComponent.defaultProps = {
  onChange: () => { },
  value: null,
  includeAllOption: false,
  disabled: false,
  includeDraftOption: true,
  size: 'large',
};

export default (InvoiceStatusSelectComponent);
